import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  mt__10: {
    marginTop: 10,
  },
  main__heading: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },

  details__header: {
    width: 80 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
  },
  details__body: {
    width: 80 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
  },

  tableRow: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
  },

  table: {
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 1,
    borderRadius: 0,
    borderBottomWidth: 0,
    overflow: 'hidden',
    marginTop: 10,
    display: 'block',
    width: 'auto',
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  tableCell: {
    margin: 5,
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
});

const ExtraAmount = ({ data }) => {
  const { currencySymbol = '$', addCommasToNumber, invoice = '' } = data;

  const { description = '' } = invoice;
  let { extraAmount = 0 } = invoice;
  extraAmount = addCommasToNumber(Math.round((+extraAmount || 0) * 100) / 100);
  return (
    <>
      {extraAmount > 0 && (
        <>
          <View style={styles.mt__10}>
            <Text style={styles.main__heading}>Extra Amount</Text>
          </View>

          <View style={styles.table}>
            <View style={styles.tableRow} wrap={false}>
              <View style={styles.details__header}>
                <Text style={styles.tableCellHeader}>Description</Text>
              </View>
              <View style={[styles.details__header, { width: 20 + '%' }]}>
                <Text style={styles.tableCellHeader}>Amount</Text>
              </View>
            </View>
            <View style={styles.tableRow} wrap={false}>
              <View style={styles.details__body}>
                <View>
                  <Text style={styles.tableCell}>{description}</Text>
                </View>
              </View>

              <View style={[styles.details__body, { width: 20 + '%' }]}>
                <Text style={styles.tableCell}>
                  {currencySymbol}
                  {extraAmount}
                </Text>
              </View>
            </View>
          </View>
        </>
      )}
    </>
  );
};
export default ExtraAmount;
